import { render, staticRenderFns } from "./ScheduleWeekDisplay.vue?vue&type=template&id=328a31b4&"
import script from "./ScheduleWeekDisplay.vue?vue&type=script&lang=js&"
export * from "./ScheduleWeekDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleWeekDisplay.vue?vue&type=style&index=0&id=328a31b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports